<template>
  <div class="recruiting-performance-jobs">
    <ul class="job-list" aria-label="Jobs">
      <DpplListItem v-if="documents.length === 0">
        <template #left>
          <div class="left-container ml-8">
            No results found.
          </div>
        </template>
      </DpplListItem>

      <DpplListItem
        v-for="document in documents"
        v-else
        :key="document.id"
        :target="isSharedPage ? '_blank' : '_self'"
        @click.stop.prevent="$router.replace({
          query: { ...$route.query, preview: document.id, type: 'document' },
        })"
      >
        <template #left>
          <div class="left-container">
            <div class="score">
              <DocumentScoreLink
                :id="document.id"
                :score="document.score_total_capped"
                :language-code="document.language_code"
              />
            </div>
            <div class="descriptive-text">
              <div class="d-flex">
                <span class="document-title">
                  {{ document.title }}
                </span>
              </div>
              <div class="company-and-location">
                {{ document.company }}
                {{ document.location ? ` - ${document.location}` : '' }}
                {{ document.ats_requisition_id ? ` - ${document.ats_requisition_id}` : '' }}
                {{ document.ats_department_name ? ` - ${document.ats_department_name}` : '' }}
              </div>
            </div>
          </div>
        </template>
        <template #right>
          <div class="right-section">
            <!-- Defaults closed_at to today if data is broken -->
            <span
              class="document-date"
            >
              {{ new Date(document.opened_at).toLocaleDateString("en-US") }}
              -
              {{ document.status === 'Open'
                ? 'Open'
                : document.closed_at
                  ? new Date(document.closed_at).toLocaleDateString("en-US")
                  : new Date().toLocaleDateString("en-US")
              }}
            </span>
          </div>

          <div
            class="right-section d-flex flex-column"
          >
            <div class="num text-textBrand">
              {{ document.days_published === null ? 'n/a' : document.days_published }}
            </div>
            <div class="num-text text-textDarkest">
              {{ document.days_published === 1 ? 'Day Live' : 'Days Live' }}
            </div>
          </div>
        </template>
      </DpplListItem>
    </ul>
  </div>
</template>

<script>
import DpplListItem from '@/components/datapeople/DpplListItem.vue';
import DocumentScoreLink from '@/components/shared/DocumentScoreLink.vue';

export default {
  name: 'RecruitingPerformanceJobs',
  components: {
    DpplListItem,
    DocumentScoreLink,
  },
  props: {
    documents: { type: Array, default: () => [] },
    isSharedPage: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="less">
.recruiting-performance-departments {
  border: 1px solid rgb(var(--v-theme-strokeDefault));
  border-radius: 8px;

  :deep(.v-list-item):last-child {
    border-bottom: none;
  }
}

.job-list {
  background-color: @white;
  border-radius: 8px;
}

.recruiting-performance-jobs {
  .left-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .score {
    min-width: 90px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .descriptive-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .document-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    padding-bottom: 4px;
    text-align: left;
  }

  .company-and-location {
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    text-align: left;
  }

  .right-section {
    padding: 0 24px;
    border-left: 1px solid rgb(var(--v-theme-strokeDefault));
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .document-date {
    font-size: 12px;
    font-weight: 300;
    line-height: 17px;
    width: 135px;
  }

  .num {
    display: block;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
  }
  .num-text {
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    white-space: nowrap;
    width: 65px;
  }
}
</style>
